export default __webpack_public_path__ + "static/media/HSMJAVA.879d458a.gif";